import React, { FC } from 'react';

interface IProp {
  width?: number;
  height?: number;
  fill?: string;
  opacity?: number;
}

const IconViaBtc: FC<IProp> = ({ width = 23, height = 23, fill = 'white', opacity }) => {
  return (
    <svg
      style={{
        display: 'inline',
        width: `${width}px`,
        height: `${height}px`,
        opacity,
      }}
      viewBox="0 0 23 23"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z" fill={fill} />
    </svg>
  );
};

export default IconViaBtc;
